import { all } from "redux-saga/effects";
import tokenWatcher from "./login";

function* rootSaga() {
  yield all([tokenWatcher()]);
}

export default rootSaga;
